import { memo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Badge, Grid } from "@mui/material";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import { useDeliveryUpsell } from "../../hooks/useDeliveryUpsell";

const NavigateDeliveryUpselling = () => {
  const navigate = useNavigate();
  const { deliveryUpsellsCount, fetchDeliveryUpsellsByStatus } = useDeliveryUpsell();
  useEffect(() => {
    fetchDeliveryUpsellsByStatus("pending");
  }, [useDeliveryUpsell]);

  return (
    <>
      <Grid item xs={12} md={3} xl={2}>
        <Button
          variant="contained"
          color="info"
          onClick={() => navigate("/home/upselling/incoming")}
          startIcon={
            <Badge color="error" variant="dot" invisible={deliveryUpsellsCount === 0}>
              <MoveToInboxIcon />
            </Badge>
          }
        >
          Solicitudes Entrantes
        </Button>
      </Grid>
    </>
  );
};

export default memo(NavigateDeliveryUpselling);
